import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsIframe {
    export const componentId = 'iframe';

    export interface IComponentData extends NICmsContentComponent.IData {
        url: string;
    }
}

@ICmsComponent<CmsIframeComponent>({
    id: NCmsIframe.componentId,
    name: 'IFrame',
    isAdvanced: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'url',
            title: 'Frame URL',
            required: true,
            default: '/'
        }
    ],
    priority: 60
})
@Component({
    selector: 'cms-iframe',
    templateUrl: 'cms-iframe.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsIframeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsIframe.IComponentData;

    constructor(private domSanitizer: DomSanitizer) {
        super();
    }

    get url() {
        if (this.component) {
            return this.domSanitizer.bypassSecurityTrustResourceUrl(<string>this.component.url);
        }
        return '';
    }
}
